export default ({
  data: { closestAdderIndex }
}) => {
  return {
    editorClosestAdderIndexFromDrag: closestAdderIndex
  }; 
};
